import { observer } from 'mobx-react-lite'
import { ContentError } from '@/components/ContentError'
import { type EditPersonalProfileDialogViewModel } from '@/features/jobs/info-gathering/individual-info/components/EditPersonalProfileDialog/EditPersonalProfileDialogViewModel'
import { type PersonalProfileViewModel } from '@/features/jobs/info-gathering/individual-info/PersonalProfileViewModel'
import { PersonalProfile } from '@/features/jobs/info-gathering/individual-info/components/PersonalProfile'

export interface PersonalProfileContainerProps {
  vm: PersonalProfileViewModel
  editVm: EditPersonalProfileDialogViewModel | null
}

export const PersonalProfileContainer = observer(
  function PersonalProfileContainer({
    vm,
    editVm,
  }: PersonalProfileContainerProps) {
    const profile = vm.profile

    if (!vm.item.completed && !editVm) {
      return null
    }

    const renderProfile = (isLoading: boolean) => (
      <PersonalProfile
        hasProfile={vm.item.completed}
        isLoading={isLoading}
        isEditable={!!editVm?.canShow}
        onEdit={editVm?.showPersonal}
        fullName={vm.fullName}
        dateOfBirth={vm.dateOfBirth}
        occupation={profile?.occupation}
        personalTaxpayerIdentificationNumber={
          profile?.personalInfo.personalTaxpayerIdentificationNumber
        }
        maskedPersonalTaxpayerIdentificationNumber={
          vm.maskedPersonalTaxpayerIdentificationNumber
        }
        phoneNumber={profile?.contactInfo.phoneNumber}
        email={profile?.contactInfo.email}
        address={profile?.contactInfo.physicalAddress}
        emptyStateActionTestId="personal-profile-empty-state-action"
        editButtonTestId="update-personal-information-button"
      />
    )

    return vm.fetch.match({
      pending: () => renderProfile(true),
      rejected: (err) => <ContentError error={err} />,
      resolved: () => renderProfile(false),
    })
  },
)
